import { memo, useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import classNames from "classnames";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import tableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { RightArrowIcon } from "@icons";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import cellStyles from "@components/history/views/cells/Cell.module.scss";
import { OrganizationActivityRow } from "../organizationActivityRow";

export interface OrganizationActivityTableCallbacks {
    onViewDetails: (row: OrganizationActivityRow) => void;
}

export const OrganizationActionsCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, OrganizationActivityRow, unknown>) => {
        const meta = useViewTableMeta<
            OrganizationActivityTableCallbacks,
            never
        >(table);

        const handleView = useCallback(() => {
            meta.callbacks?.onViewDetails(row.original);
        }, [meta.callbacks, row.original]);

        return (
            <ViewTableCell className={cellStyles.actions} captureClicks>
                <Button
                    variant="primary"
                    size="md"
                    onClick={handleView}
                    title="View details"
                    aria-label="View details"
                    className={classNames(
                        cellStyles.viewDetailsButton,
                        tableStyles.showOnHover,
                    )}
                    rightIcon={<RightArrowIcon />}
                >
                    <span className={cellStyles.viewDetailsButtonText}>
                        View
                    </span>
                </Button>
            </ViewTableCell>
        );
    },
);

OrganizationActionsCell.displayName = "OrganizationActionsCell";
